import React, { useState, useEffect } from 'react';
import { ultimasNoticias } from '../../json/ultimasNoticias';
import './ultimasnoticias.css';

// Agrupa las noticias en bloques de "size" (uno por cada slide del carrusel)
const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// Define cuántas tarjetas mostrar por slide según el ancho de pantalla
const getItemsPerSlide = () => {
  if (window.innerWidth <= 768) return 1;
  return 2;
};

const UltimasNoticias = () => {
  const [itemsPerSlide, setItemsPerSlide] = useState(getItemsPerSlide());

  useEffect(() => {
    const handleResize = () => {
      setItemsPerSlide(getItemsPerSlide());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const grupos = chunkArray(ultimasNoticias, itemsPerSlide);

  return (
    <div id='ultimas_noticias'>
      <div className='row'>
        <div className='col-12'>
          <div className='notice_section'>
            <div className='notice_title'>
              <h3 className='title'>ÚLTIMAS NOTICIAS</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='notice_content_full'>
              <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">

                <div className="carousel-inner">
                  {
                    grupos.map((grupo, indexGrupo) => (
                      <div key={ indexGrupo } className={ indexGrupo === 0 ? "carousel-item active" : "carousel-item" }>
                        <div className="notice-grid">
                          {
                            grupo.map((item, index) => (
                              <a
                                key={ index }
                                href={ item.url }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="notice-card"
                              >
                                <div className="notice-card-img" style={{ backgroundImage: `url("${ item.imagen }")` }}>
                                  <span className="noticia-badge">
                                    { item.categoria || 'Noticia' }
                                  </span>
                                  <div className='overlay-gradient-card'></div>
                                </div>
                                <div className="notice-card-body">
                                  <p className='fecha_noticia'>
                                    <i className="fa-regular fa-calendar"></i> { item.fecha }
                                  </p>
                                  <h6>{ item.titulo }</h6>
                                  <span className='leer_mas'>Leer más <i className="fa-solid fa-arrow-right"></i></span>
                                </div>
                              </a>
                            ))
                          }
                        </div>
                      </div>
                    ))
                  }
                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                  <span className="control-circle">
                    <i className="fa-solid fa-chevron-left"></i>
                  </span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                  <span className="control-circle">
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                  <span className="visually-hidden">Next</span>
                </button>

                {
                  grupos.length > 1 &&
                  <div className="carousel-indicators-custom">
                    {
                      grupos.map((grupo, index) => (
                        <button
                          key={ index }
                          type="button"
                          data-bs-target="#carouselExampleControls"
                          data-bs-slide-to={ index }
                          className={ index === 0 ? "active" : "" }
                          aria-label={`Grupo de noticias ${index + 1}`}
                        ></button>
                      ))
                    }
                  </div>
                }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UltimasNoticias